import React from "react";
import {
	FaFlag,
	FaExclamationCircle,
	FaExclamation,
	FaMapMarkerAlt,
	FaCalendarAlt,
} from "react-icons/fa";
import { formatDate } from "../../../utils/dateUtils";
import { getBackgroundColor, getLevelIcon, getPriorityText } from "../../../utils/priorityUtils";
import ImageModalTemplate from "./ImageModalTemplate";

const AlertImageModal = ({ onClose, alertData, mode }) => {
	return (
		<ImageModalTemplate
			onClose={onClose}
			downloadName={"alert_" + alertData.id}
			classNameCard={getBackgroundColor(alertData.category_name, alertData.priority)}
		>
			{/* Icona Header */}
			<div className="flex justify-center text-7xl mb-4">
				{getLevelIcon(alertData.priority)}
			</div>

			<h2 className="text-3xl font-bold text-center text-blue-600 mb-4">{alertData.title}</h2>

			{mode && (
				<p className="text-center text-gray-700 italic text-lg mb-2">
					<strong>
						{mode === "allarmeteo"
							? "Centro Funzionale Abruzzo"
							: "Allerta Comunale Atri"}
					</strong>
				</p>
			)}

			{alertData.category_name && (
				<p className="flex items-center gap-2 py-3 text-xl">
					<FaFlag className="text-purple-500 text-3xl" />
					<strong className="text-blue-600 w-full">{alertData.category_name}</strong>
				</p>
			)}

			{alertData.priority && (
				<p className="flex items-center gap-2 py-3 text-xl">
					<FaExclamation className="text-red-500 text-3xl" />
					<strong className="text-blue-600">Priorità:</strong>
					<span className="w-full">{getPriorityText(alertData.priority)}</span>
				</p>
			)}

			{alertData.description && (
				<p className="flex items-center gap-2 py-3 text-xl">
					<FaExclamationCircle className="text-yellow-500 text-3xl" />
					<strong className="text-blue-600">Descrizione:</strong>
					<span className="w-full">{alertData.description}</span>
				</p>
			)}

			{alertData.area_name && (
				<p className="flex items-center gap-2 py-3 text-xl">
					<FaMapMarkerAlt className="text-teal-500 text-3xl" />
					<strong className="text-blue-600">Area:</strong>
					<span className="w-full">{alertData.area_name}</span>
				</p>
			)}

			{alertData.expire_date && (
				<p className="flex items-center gap-2 py-3 text-xl">
					<FaCalendarAlt className="text-green-500 text-3xl" />
					<span className="w-full">
						<strong className="text-blue-600">Valido dalle </strong>
						{formatDate(alertData.valid_date)}
						<strong className="text-blue-600">
							<br />
							alle{" "}
						</strong>
						{formatDate(alertData.expire_date)}
					</span>
				</p>
			)}
		</ImageModalTemplate>
	);
};

export default AlertImageModal;
